module.exports = __webpack_public_path__ + "img/part4-dIcon8.bd20eec7.png";